import { resultsetWithFields } from 'vlcishared';

function mostrarMapaIntervenciones(token) {
  const URL_SIGVAL =
    'https://sigval.valencia.es/portal/apps/webappviewer/index.html?id=';

  const ID_MAPA_INTERVENCIONES_HOY =
    '36e2ec207cd9477581d4479eb472fcc4&mobileBreakPoint=300';
  const ID_MAPA_INTERVENCIONES_MENSUAL =
    '460cf69d4a384cf1bc29746faab26ed5&mobileBreakPoint=300';
  const ID_MAPA_INTERVENCIONES_ANUAL =
    'b9e76df1f7c8490c9b0a06ef5fedcf83&mobileBreakPoint=300';

  try {
    const iframeMapaIntervencionesHoy = document.querySelector(
      '#if-intervenciones-hoy',
    );
    const iframeMapaIntervencionesMensual = document.querySelector(
      '#if-intervenciones-mensual',
    );
    const iframeMapaIntervencionesAnual = document.querySelector(
      '#if-intervenciones-anual',
    );

    if (iframeMapaIntervencionesHoy) {
      iframeMapaIntervencionesHoy.setAttribute(
        'src',
        `${URL_SIGVAL}${ID_MAPA_INTERVENCIONES_HOY}&token=${token}`,
      );
    }
    if (iframeMapaIntervencionesMensual) {
      iframeMapaIntervencionesMensual.setAttribute(
        'src',
        `${URL_SIGVAL}${ID_MAPA_INTERVENCIONES_MENSUAL}&token=${token}`,
      );
    }
    if (iframeMapaIntervencionesAnual) {
      iframeMapaIntervencionesAnual.setAttribute(
        'src',
        `${URL_SIGVAL}${ID_MAPA_INTERVENCIONES_ANUAL}&token=${token}`,
      );
    }
  } catch (error) {
    console.error(
      'No se pudo cargar el token, y por tanto, no se han podido mostrar los mapas. Error:',
      error,
    );
  }
}

export function setToken(data) {
  const resultSet = resultsetWithFields(data);
  const { token } = resultSet[0];
  if (!token) {
    throw new Error('No se pudo obtener el token desde base de datos');
  }
  mostrarMapaIntervenciones(token);
}
